export const status = {
  available: 'AVAILABLE',
  tariffExpired: 'TARIFF_EXPIRED',
  testingRequired: 'TESTING_REQUIRED',
  purchaseRequired: 'PURCHASE_REQUIRED',
  premiumRequired: 'PREMIUM_REQUIRED'
}
